import {
  TEAM_GROUP_FIND_ALL,
  TEAM_GROUP_SET_INITIAL_STATE,
  TEAM_GROUP_VIEW
} from './teamGroupTypes'


const initialState = {
  data: [],
  pagination: {
    currentpage: 1,
    itemcount: 0,
    pagesize: 10,
    firstpage: '',
    lastpage: '',
    nextpages: [],
    prevpages: [],
    totalpages: 0
  },

  viewResult: false
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case TEAM_GROUP_SET_INITIAL_STATE:
      return initialState;
    case TEAM_GROUP_FIND_ALL:
      return {
        data: action.payload.data,
        pagination: action.payload.pagination
      }
    case TEAM_GROUP_VIEW:
    return {
      ...state,
      viewResult: action.payload.data
    }
    default: return state
  }
}

export default reducer
